// extracted by mini-css-extract-plugin
export default {"toggleButton":"toggleButton_nxjP"};